import React, { FunctionComponent } from 'react';
import FormText from 'reactstrap/lib/FormText';
import Input from 'reactstrap/lib/Input';
import Label from 'reactstrap/lib/Label';

import { Error } from '../Error';

export interface ITextProps {
  onChange?: (e?: any) => any;
  isValid?: boolean;
  infoMessage?: string;
  label?: string;
  name?: string;
  value?: string | string[];
  defaultValue?: string | string[];
  placeholder?: string;
  errorMessage?: string;
  disabled?: boolean;
  textarea?: boolean;
  required?: boolean;
}

export const Text: FunctionComponent<ITextProps> = (props: ITextProps) => {
  return (
    <Label className="w-100">
      {props.label ? props.label : null}
      <Input
        className="mb-2 mt-1"
        onChange={props.onChange}
        defaultValue={props.defaultValue || undefined}
        value={props.value || undefined}
        name={props.name || undefined}
        placeholder={props.placeholder || undefined}
        type={props.textarea === true ? "textarea" : (props.name === 'password' || props.name === 'passwordRepeat' ? 'password' : undefined)}
        required={props.required}
        disabled={props.disabled}
      // style={{ backgroundColor: '#ebecf1', borderRadius: '10px' }}
      />
      {props.infoMessage ? (
        <FormText color="muted">{props.infoMessage}</FormText>
      ) : null}
      {props.isValid === false ? <Error>{props.errorMessage}</Error> : null}
    </Label>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/form/modules/input/Text.tsx